/* eslint-disable */
import { Button, Divider, Grid, IconButton, Stack, TextField, Tooltip, Typography, Skeleton } from "@mui/material";
import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import { getAlllistings, getSingleUniversity } from "../../services";
// import { setPopup } from "../../store/Slices/popupSlice";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Event, UniversityListObj } from "../../types/types";
// import ThermostatIcon from "@mui/icons-material/Thermostat";
import Images from "../../assets";
import { ArrowBack } from "@mui/icons-material";
import Share from "./share";
import TimerIcon from "@mui/icons-material/Timer";
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import ConfusedCard from "./confusedCard";
import { setWordCase } from "../../assets/library";
import { setPopup } from "../../store/slices/popupSlice";
import { initReviews } from "../../store/slices/reviewSlice";
import { formatCurrencyAmount } from "../../assets/currencyUtils";
import { monthNames } from "../../assets/menu";
import CustomTabs from "../../components/tabs";

// Function to filter ranking data by year (show only previous year's data)
const filterRankingByYear = (rankingData: any) => {
  if (!rankingData || typeof rankingData !== 'object') {
    return {};
  }

  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  
  const filteredRanking: any = {};
  
  Object.entries(rankingData).forEach(([key, value]) => {
    // Check if the key contains the previous year
    if (key.includes(previousYear.toString())) {
      filteredRanking[key] = value;
    }
  });
  
  return filteredRanking;
};

const UniversityDetailed = (props: any) => {
  const [singleUniversityData, setSingleCourseData] =
    useState<UniversityListObj | null>(null);
  const currency = localStorage.getItem("currency");
  const preferences ={data:{currency:"INR"}}//useAppSelector((state) => state.preferences);
  const userAuthStatus = useAppSelector((state) => state.userAuthStatus);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [tabComponent, setTabComponent] = useState< "tabs" | "share">("tabs");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCourses, setTotalCourses] = useState<any>([]);
  const coursesCacheRef = useRef<Map<string, any>>(new Map());
  const reviewsData = useAppSelector(state =>state.reviews) as any;

  // Memoize filter data to prevent unnecessary re-renders
  const filterdata = useMemo(() => ({
    page: currentPage,
    filterData: [{ type: "universityId", data: [props.data] }],
    currency: preferences?.data?.currency || localStorage.getItem("currency"),
  }), [currentPage, props.data, preferences?.data?.currency]);

  // Optimized course listings with caching and error handling
  const courseListings = useCallback(async () => {
    if (!props.data) return;
    
    const cacheKey = `${props.data}-${currentPage}-${filterdata.currency}`;
    
    // Check cache first
    if (coursesCacheRef.current.has(cacheKey)) {
      const cachedData = coursesCacheRef.current.get(cacheKey);
      if (currentPage > 1) {
        setTotalCourses((prev: any[]) => [...prev, ...cachedData.list]);
      } else {
        setTotalCourses(cachedData.list);
      }
      setTotalPages(cachedData.totalPages);
      return;
    }

    setCoursesLoading(true);
    try {
      const response = await getAlllistings("courses", filterdata);
      if (response?.data) {
        const { list, totalPages: pages } = response.data;
        
        // Cache the response
        coursesCacheRef.current.set(cacheKey, { list, totalPages: pages });
        
        if (currentPage > 1) {
          setTotalCourses((prev: any[]) => [...prev, ...list]);
        } else {
          setTotalCourses(list);
        }
        setTotalPages(pages);
      }
    } catch (error) {
      console.error("Error loading courses:", error);
      // Handle error gracefully
      if (currentPage === 1) {
        setTotalCourses([]);
      }
    } finally {
      setCoursesLoading(false);
    }
  }, [currentPage, filterdata, props.data]);

  useEffect(() => {
    courseListings();
  }, [courseListings]);


  const singleUniversity = async () => {
    try {
      if (props.data !== null) {
        setLoading(true);
        const response = await getSingleUniversity(
          props.data,
          preferences?.data?.currency || currency || "INR"
        );
        if (response) {
          setSingleCourseData(response?.data?.data);
          dispatch(
            initReviews({
              requestStatus: "initiated",
              responseStatus: "recieved",
              haveAnIssue: false,
              issue: "",
              data: response.data.data.userReviews,
            })
          );
        } else {
          console.log("Error");
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (props.data !== "null") {
      singleUniversity();
    }
    // eslint-disable-next-line
  }, [props.data]);

  const Information = ({ data }: any) => {
    return (
      <>
      <div>
        <Box sx={{ mb: 1, pr: 2 }}>
          <Typography fontSize="15px" sx={{ color: "#495052", lineHeight: "2.2" }}>
            {data?.about}
          </Typography>

          <Contact singleUniversityData={data} />
        </Box>
      </div>
       <Box sx={{marginTop:5,px:2}}>
            <ConfusedCard isSmall={true} />
          </Box>
          </>
    );
  };
  const UniverInformation = ({ data }: any) => {
    return (
      <div style={{ display: "flex", gap: "2rem",padding:"0 3rem" ,flexDirection:"column"}}>
<Box sx={{display:"flex",gap:"2rem",justifyContent:"center",alignItems:"center"}}>
        <Box sx={{ mb: 1, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "0.8rem" }}>
          <SchoolOutlinedIcon />
          <Typography color="#1C1F40" fontWeight="600" sx={{ fontSize: "1.25rem" }}>{setWordCase(data?.type)}</Typography>

          <Typography
            // fontWeight="600"
            fontSize="16px"
            gutterBottom
            color="#858585"
          >
            University type
          </Typography>
        </Box>
        <Divider orientation="vertical" variant="middle" flexItem sx={{ border: "2px solid #1C1F40", height: "85px" }} />
        <Box sx={{ mb: 1, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "0.8rem" }}>
          <img src={Images.readingBook} alt="" style={{ width: "1.8rem", height: "1.8rem" }} />

          <Typography color="#1C1F40" fontWeight="600" sx={{ fontSize: "1.25rem" }}>{data?.establishedYear}</Typography>

          <Typography
            // fontWeight="600"
            fontSize="16px"
            gutterBottom
            color="#858585"
          >
            Established year
          </Typography>
        </Box>
        </Box>
      </div>
    );
  };
   // eslint-disable-next-line
   const FAQs = ({ data }: any) => {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", padding: {lg:"0 3rem"} }}>
        <Grid container spacing={4}>
          {/* <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <Box >
              <Typography sx={{ fontSize: "1.5rem", color: "#3b3f76", fontWeight: "600",mb:2 }}>FAQS</Typography>
                <Typography color="#30336380" textAlign="start" sx={{width:"80%"}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has </Typography>
              </Box>
          </Grid> */}
          <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "start", flexDirection: "column" }}>
            {data?.map((faq: any, index: number) => {
              return (
                <Accordion
                  key={index}
                  sx={{ background: "transparent", gap: "10px", borderRadius: "6px", mb: 2, boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#495052" }} />}
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                  >
                    <Typography color="#495052" fontWeight="450">
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ background: "transparent" }}>
                    <Typography>
                      {faq?.answer || "No answer available"}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Grid>
        </Grid>
      </Box>
    );
  };
  const Contact = ({ singleUniversityData }: any) => {
    return (
      <div>
        <Grid
          container
          spacing={3}
          sx={{
            // marginTop: "-12px",
            my: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap:"1.2rem"
          }}
        >
          {singleUniversityData?.contact?.snapchat ? (
            <Grid item xs={1}>
              <a
                href={singleUniversityData?.contact?.snapchat}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images.Snapchat}
                  alt="website"
                  style={{ width: "2rem" }}
                />
              </a>
            </Grid>
          ) : (
            ""
          )}
          {singleUniversityData?.contact?.twitter ? (
            <Grid item xs={1}>
              <a
                href={singleUniversityData?.contact?.twitter}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images.Twitter}
                  alt="website"
                  style={{ width: "2rem" }}
                />
              </a>
            </Grid>
          ) : (
            ""
          )}
          {singleUniversityData?.contact?.youtube ? (
            <Grid item xs={1}>
              <a
                href={singleUniversityData?.contact?.youtube}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images.Youtube}
                  alt="website"
                  style={{ width: "2rem" }}
                />
              </a>
            </Grid>
          ) : (
            ""
          )}
          {singleUniversityData?.contact?.officialWebsite ? (
            <Grid item xs={1}>
              <a
                href={singleUniversityData?.contact?.officialWebsite}
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={Images.Websitelink}
                  alt="website"
                  style={{ width: "2rem" }}
                />
              </a>
            </Grid>
          ) : (
            ""
          )}
          {singleUniversityData?.contact?.facebook ? (
            <Grid item xs={1}>
              <a
                href={singleUniversityData?.contact?.facebook}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images.Facebooklink}
                  alt="website"
                  style={{ width: "2rem" }}
                />
              </a>
            </Grid>
          ) : (
            ""
          )}
          {singleUniversityData?.contact?.instagram ? (
            <Grid item xs={1}>
              <a
                href={singleUniversityData?.contact?.instagram}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images.Instalink}
                  alt="website"
                  style={{ width: "2rem" }}
                />
              </a>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </div>
    );
  };

  // Function to generate course-specific social media links based on university name
  const generateCourseSocialLinks = (universityName: string, courseName: string) => {
    const university = universityName?.toLowerCase()?.replace(/\s+/g, '') || '';
    const course = courseName?.toLowerCase()?.replace(/\s+/g, '') || '';
    
    // Define social media link patterns for different universities
    const socialLinks: { [key: string]: any } = {
      'harvard': {
        facebook: `https://www.facebook.com/harvarduniversity`,
        twitter: `https://twitter.com/Harvard`,
        instagram: `https://www.instagram.com/harvard/`,
        youtube: `https://www.youtube.com/user/Harvard`,
        linkedin: `https://www.linkedin.com/school/harvard-university/`
      },
      'mit': {
        facebook: `https://www.facebook.com/MITnews`,
        twitter: `https://twitter.com/MIT`,
        instagram: `https://www.instagram.com/mit/`,
        youtube: `https://www.youtube.com/user/MIT`,
        linkedin: `https://www.linkedin.com/school/massachusetts-institute-of-technology/`
      },
      'stanford': {
        facebook: `https://www.facebook.com/Stanford`,
        twitter: `https://twitter.com/Stanford`,
        instagram: `https://www.instagram.com/stanford/`,
        youtube: `https://www.youtube.com/user/StanfordUniversity`,
        linkedin: `https://www.linkedin.com/school/stanford-university/`
      },
      'oxford': {
        facebook: `https://www.facebook.com/the.university.of.oxford`,
        twitter: `https://twitter.com/UniofOxford`,
        instagram: `https://www.instagram.com/oxford_uni/`,
        youtube: `https://www.youtube.com/user/oxford`,
        linkedin: `https://www.linkedin.com/school/university-of-oxford/`
      },
      'cambridge': {
        facebook: `https://www.facebook.com/cambridge.university`,
        twitter: `https://twitter.com/Cambridge_Uni`,
        instagram: `https://www.instagram.com/cambridgeuniversity/`,
        youtube: `https://www.youtube.com/user/CambridgeUniversity`,
        linkedin: `https://www.linkedin.com/school/university-of-cambridge/`
      }
    };

    // Return social links for the university, or default links if not found
    return socialLinks[university] || {
      facebook: `https://www.facebook.com/search/top/?q=${encodeURIComponent(universityName || '')}`,
      twitter: `https://twitter.com/search?q=${encodeURIComponent(universityName || '')}`,
      instagram: `https://www.instagram.com/explore/tags/${encodeURIComponent((universityName || '').replace(/\s+/g, ''))}/`,
      youtube: `https://www.youtube.com/results?search_query=${encodeURIComponent((universityName || '') + ' ' + (courseName || ''))}`,
      linkedin: `https://www.linkedin.com/search/results/companies/?keywords=${encodeURIComponent(universityName || '')}`
    };
  };

  // Skeleton component for loading states
  const CourseCardSkeleton = () => (
    <Box
      sx={{
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        p: 2.5,
        bgcolor: '#F8F8FC',
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
        <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
        <Box sx={{ flexGrow: 1 }}>
          <Skeleton variant="text" width="80%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="60%" height={16} />
        </Box>
      </Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {[...Array(4)].map((_, index) => (
          <Grid item xs={6} key={index}>
            <Skeleton variant="text" width="40%" height={14} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="60%" height={16} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  const CoursesOffered = ({ data }: any) => {
    // Memoized Card component to prevent unnecessary re-renders
    const Card = React.memo(({ data, i }: { data: any; i: number }) => {
      const item = data.data;
      const userAuthStatus = useAppSelector((state) => state.userAuthStatus);
      const shortlisted ={data:[]} //useAppSelector((state) => state.shortlistedcourses);
      const dispatch = useAppDispatch();
      const [loadingMap, setLoadingMap] = useState<{ [key: string]: boolean }>({});

      // Memoize shortlist check to avoid recalculation on every render
      const isShortlisted = useMemo(() => 
        shortlisted.data.some((shortlistedCourse: any) => shortlistedCourse._id === item._id),
        [shortlisted.data, item._id]
      );
      
      // Optimized event handler with better error handling and 

      return (
        <Box
          onClick={() => {
            dispatch(
              setPopup({
                show: true,
                data: {
                  container: {
                    name: 'mainPopup',
                    data: item,
                    dimensions: { width: '95%' },
                  },
                  type: 'custom',
                },
              })
            );
          }}
          sx={{
            borderRadius: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            p: 2.5,
            bgcolor: '#F8F8FC',
            position: 'relative',
            mb: 2,
            minHeight: 210,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
              boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
              transform: 'translateY(-2px)',
            },
          }}
        >
          {/* Featured badge - positioned at top left to avoid heart icon */}
          {item.featured && (
            <Chip 
              label="Featured" 
              size="small"
              sx={{ 
                position: 'absolute',
                top: 8,
                left: 8,
                zIndex: 2,
                fontSize: 11, 
                height: 20, 
                bgcolor: '#FF9784',
                color: 'white',
                '& .MuiChip-label': { px: 1 }
              }} 
            />
          )}
          
          {/* Heart icon - positioned at top right with fixed positioning */}
          <Box sx={{ 
            position: 'absolute', 
            top: 8, 
            right: 8, 
            zIndex: 3,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '50%',
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
          </Box>

          {/* Header with logo and course title */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            mb: 2,
            mt: item.featured ? 3 : 1, // Add top margin when featured badge is present
            pr: 5 // Add right padding to avoid heart icon overlap
          }}>
            <Avatar 
              src={item.university?.logoSrc} 
              sx={{ 
                mr: 2, 
                width: 40, 
                height: 40,
                bgcolor: '#FF6B6B',
                border: '2px solid #fff',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }} 
            />
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Typography 
                fontWeight={700} 
                sx={{ 
                  fontSize: 16, 
                  lineHeight: 1.3,
                  color: '#1C1F40',
                  mb: 0.5,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  pr: 1 // Ensure text doesn't overlap with heart icon
                }}
              >
                {item.name}
              </Typography>
              <Typography 
                color="#858585" 
                sx={{ 
                  fontSize: 12,
                  mb: 0.5,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  pr: 1
                }}
              >
                {item.university?.name} | {item.university?.location?.country}
              </Typography>
              {item.applySoon && (
                <Chip 
                  label="Apply Soon" 
                  size="small"
                  sx={{ 
                    fontSize: 11, 
                    height: 20, 
                    bgcolor: '#FFE5E5',
                    color: '#FF6B6B',
                    '& .MuiChip-label': { px: 1 }
                  }} 
                />
              )}
            </Box>
          </Box>

          {/* Course details grid */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6}>
              <Typography 
                variant="body2" 
                color="#858585" 
                sx={{ fontSize: 10, mb: 0.5 }}
              >
                Study Level
              </Typography>
              <Typography 
                fontWeight={400} 
                sx={{ 
                  fontSize: 12,
                  color: 'black'
                }}
              >
                {item.studyLevel || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography 
                variant="body2" 
                color="#858585" 
                sx={{ fontSize: 10, mb: 0.5 }}
              >
                Duration
              </Typography>
              <Typography 
                fontWeight={400} 
                sx={{ 
                  fontSize: 12,
                  color: 'black'
                }}
              >
                {item.duration?.length ? `${item.duration[0].duration} Months` : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography 
                variant="body2" 
                color="#858585" 
                sx={{ fontSize: 10, mb: 0.5 }}
              >
                Tuition fee
              </Typography>
              <Typography 
                fontWeight={400} 
                sx={{ 
                  fontSize: 12,
                  color: 'black',
                  display: 'flex',
                  alignItems: 'baseline',
                  flexWrap: 'nowrap'
                }}
              >
                {item.tuitionFee?.tuitionFee ? formatCurrencyAmount(item.tuitionFee.tuitionFee, item.currency?.code || 'INR') : 'N/A'}
                {item.tuitionFee?.tuitionFee && (
                  <Box
                    component="span"
                    sx={{
                      fontSize: '0.6em',
                      lineHeight: 1,
                      ml: 0.3,
                      verticalAlign: 'super',
                      position: 'relative',
                      top: '-0.3em',
                      color: 'black'
                    }}
                  >
                    {item.currency?.code}
                  </Box>
                )}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography 
                variant="body2" 
                color="#858585" 
                sx={{ fontSize: 10, mb: 0.5 }}
              >
                Course Starts
              </Typography>
              <Typography 
                fontWeight={400} 
                sx={{ 
                  fontSize: 12,
                  color: 'black',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {item.startDate?.length ? item.startDate.map((s: any) => monthNames[s.courseStartingMonth]).join(' | ') : 'N/A'}
              </Typography>
            </Grid>
          </Grid>

          {/* Bottom right tags container - absolutely positioned */}
          {(item.feature || item.loanDetails?.loan || item.applicationDetails?.applicationFeeWaiver) && (
            <Box sx={{ 
              position: 'absolute',
              bottom: -8,
              right: 2,
              bgcolor: 'white', 
              borderRadius: '20px', 
              px: 1, 
              py: 0.5,
              minWidth: 'fit-content',
              width: 'auto',
              zIndex: 2,
              display: 'flex',
              gap: 0.5,
              flexWrap: 'wrap'
            }}>
              {item.feature && (
                <Chip 
                  label="Direct Admit" 
                  size="small"
                  sx={{ 
                    fontSize: 11, 
                    height: 24, 
                    bgcolor: '#8B5CF6',
                    color: 'white',
                    '& .MuiChip-label': { px: 1.5 }
                  }} 
                />
              )}
              {item.loanDetails?.loan && (
                <Chip 
                  label="Loan Assurance" 
                  size="small"
                  sx={{ 
                    fontWeight:"600",
                    fontSize: 11, 
                    height: 24, 
                    bgcolor: '#FFF1DD',
                    color: '#495052',
                    '& .MuiChip-label': { px: 1.5 }
                  }} 
                />
              )}
              {item.applicationDetails?.applicationFeeWaiver && (
                <Chip 
                  label="No cost EMI" 
                  size="small"
                  sx={{ 
                    fontSize: 11, 
                    height: 24, 
                    bgcolor: '#3B82F6',
                    color: 'white',
                    '& .MuiChip-label': { px: 1.5 }
                  }} 
                />
              )}
            </Box>
          )}

          {/* Social Media Links Section */}
          {/* <Box sx={{ 
            mt: 2, 
            pt: 1, 
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'center',
            gap: 1
          }}>
            <Typography 
              variant="body2" 
              color="#858585" 
              sx={{ 
                fontSize: 10, 
                mb: 1,
                textAlign: 'center',
                width: '100%'
              }}
            >
              Follow {item.university?.name} on Social Media
            </Typography>
            <Grid container spacing={1} justifyContent="center">
              {(() => {
                const socialLinks = generateCourseSocialLinks(item.university?.name, item.name);
                return (
                  <>
                    <Grid item>
                      <a
                        href={socialLinks.facebook}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        <img
                          src={Images.Facebooklink}
                          alt="Facebook"
                          style={{ 
                            width: "1.5rem", 
                            height: "1.5rem",
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease-in-out'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        />
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        href={socialLinks.twitter}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        <img
                          src={Images.Twitter}
                          alt="Twitter"
                          style={{ 
                            width: "1.5rem", 
                            height: "1.5rem",
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease-in-out'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        />
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        href={socialLinks.instagram}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        <img
                          src={Images.Instalink}
                          alt="Instagram"
                          style={{ 
                            width: "1.5rem", 
                            height: "1.5rem",
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease-in-out'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        />
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        href={socialLinks.youtube}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        <img
                          src={Images.Youtube}
                          alt="YouTube"
                          style={{ 
                            width: "1.5rem", 
                            height: "1.5rem",
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease-in-out'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        />
                      </a>
                    </Grid>
                  </>
                );
              })()}
            </Grid>
          </Box> */}
        </Box>
      );
    });

    return (
      <div>
        <Box sx={{ mb: 1, padding: { md: '1rem 0', xs: '0 1rem' }, maxHeight: 500, overflowY: 'auto' }}>
          {coursesLoading && data?.length === 0 ? (
            // Show skeleton loading for initial load
            <Grid container spacing={2}>
              {[...Array(4)].map((_, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <CourseCardSkeleton />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={2}>
              {data?.map((item: any, i: number) => (
                <Grid item xs={12} md={6} key={item._id || i}>
                  <Card data={{ data: item }} i={i} />
                </Grid>
              ))}
              {coursesLoading && data?.length > 0 && (
                // Show skeleton for pagination loading
                <>
                  <Grid item xs={12} md={6}>
                    <CourseCardSkeleton />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CourseCardSkeleton />
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </Box>
      </div>
    );
  };
  const Ranking = ({ data }: any) => {
    const backgroundColors = ["#E1F4FF", "#EAEAFF"];
    
    // Filter ranking data to show only previous year's data
    // const filteredRankingData = filterRankingByYear(data?.rank);
    const filteredRankingData =data?.rank;
    return (
      <div>
        <Box sx={{ mb: 1, padding: {md:"0 3rem",xs:"0 1rem"} }}>
          <Grid container spacing={2}>
            {filteredRankingData && Object?.entries(filteredRankingData)?.map(([key, value], index) => (
              <Grid item xs={12} md={6} key={index}>
                <Box
                  sx={{
                    backgroundColor: backgroundColors[index % backgroundColors.length],
                    borderRadius: "20px",
                    p: 2,
                    position: "relative",
                    height:"5rem"
                  }}
                >
                  <Typography fontWeight="600">{value as React.ReactNode}</Typography>
                  <Typography color="#1C1F40" sx={{ fontSize: "0.8rem", width: "80%" }}>
                    {key}
                  </Typography>
                  <img
                    src={Images.universityMask}
                    alt="university"
                    style={{
                      width: "5rem",
                      position: "absolute",
                      bottom: 0,
                      right: 0
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </div>
    );
  };
  const ReviewsData = () => {
    const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
    const [selectedRating, setSelectedRating] = useState(0);
    const [hoveredRating, setHoveredRating] = useState(0);
    const [reviewComment, setReviewComment] = useState('');
    const [localReviews, setLocalReviews] = useState<any[]>([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [savedReview, setSavedReview] = useState<any>(null);
    const hasReviews = (reviewsData?.data?.length > 0) || (localReviews.length > 0);
    const totalReviews = (reviewsData?.data?.length || 0) + localReviews.length;
    
    const handleNext = () => {
      setCurrentReviewIndex((prev) => (prev + 1) % totalReviews);
    };
    
    const handlePrev = () => {
      setCurrentReviewIndex((prev) => (prev - 1 + totalReviews) % totalReviews);
    };

    const handleStarClick = (rating: number) => {
      setSelectedRating(rating);
    };

    const handleStarHover = (rating: number) => {
      setHoveredRating(rating);
    };

    const handleStarLeave = () => {
      setHoveredRating(0);
    };

    const handleSaveReview = () => {
      if (selectedRating === 0) {
        alert('Please select a rating before saving');
        return;
      }
      if (!reviewComment.trim()) {
        alert('Please add a comment before saving');
        return;
      }
      
      // Create new review object
      const newReview = {
        _id: `local_${Date.now()}`,
        comment: reviewComment,
        rating: selectedRating,
        user: {
          firstName: 'You',
          lastName: '',
          displayPicSrc: 'https://via.placeholder.com/40'
        },
        createdAt: new Date().toISOString()
      };
      
      // Add to local reviews
      setLocalReviews(prev => [...prev, newReview]);
      
      // Here you would typically save the review to your backend
      console.log('Saving review:', {
        rating: selectedRating,
        comment: reviewComment,
        universityId: props.data
      });
      
      // Show success message and save the review for display
      setSavedReview(newReview);
      setShowSuccessMessage(true);
      
      // Reset form
      setSelectedRating(0);
      setReviewComment('');
    };

    const handleContinue = () => {
      setShowSuccessMessage(false);
      setSavedReview(null);
    };

    const handleWriteAnotherReview = () => {
      setShowSuccessMessage(false);
      setSavedReview(null);
      setSelectedRating(0);
      setReviewComment('');
    };

    // Get reviews to display (show 2 at a time)
    const getDisplayReviews = () => {
      if (!hasReviews) return [];
      const allReviews = [...(reviewsData.data || []), ...localReviews];
      const startIndex = currentReviewIndex;
      const endIndex = Math.min(startIndex + 2, allReviews.length);
      return allReviews.slice(startIndex, endIndex);
    };

    const displayReviews = getDisplayReviews();
    const canShowNext = totalReviews > 2 && currentReviewIndex < totalReviews - 2;
    const canShowPrev = totalReviews > 2 && currentReviewIndex > 0;

         return (
       <Box sx={{ width: '90%', py: hasReviews ? 4 : 2, maxHeight: hasReviews ? "auto" : "200px", px: 3, mt: 4 }}>
         <Grid container spacing={4} justifyContent="center">
           {hasReviews ? (
            <>
              {/* Navigation Arrow - Left */}
              {canShowPrev && (
                <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <IconButton
                    onClick={handlePrev}
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: '50%',
                      backgroundColor: '#FFF1DD',
                      color: '#F48438',
                      '&:hover': {
                        backgroundColor: '#F48438',
                        color: 'white',
                      },
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }}
                  >
                    <KeyboardArrowLeftIcon />
                  </IconButton>
                </Grid>
              )}

              {/* Review Cards */}
              <Grid item xs={10}>
                <Grid container spacing={3} justifyContent="center">
                  {displayReviews.map((review, index) => (
                    <Grid item xs={12} md={6} key={index}>
                                             <Box
                         sx={{
                           background: '#fff',
                           borderRadius: '30px',
                           border: '1px solid #E0E0E0',
                           p: 2,
                           height: '100%',
                           minHeight: 200,
                           position: 'relative',
                           boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                           display: 'flex',
                           flexDirection: 'column',
                         }}
                       >
                                                 {/* Quote Icon */}
                         <Box
                          
                         >
                           <img style={{height:"20px"}} src={Images.ReviewQuote}/>
                         </Box>

                                                 {/* Review Text */}
                         <Typography
                           sx={{
                             color: '#666',
                             fontSize: '0.85rem',
                             lineHeight: 1.5,
                             mt: 1,
                             mb: 1.5,
                             flex: 1,
                             fontStyle: 'italic',
                           }}
                         >
                          {review.comment || 'Thanks to the amazing team at One Window, I was able to fulfill my dream of studying in the UK. Their guidance throughout the application process was invaluable, and they made everything so smooth and stress-free.'}
                        </Typography>

                                                                           {/* Star Rating */}
                          <Box sx={{ display: 'flex', gap: 0.3, mb: 1.5 }}>
                            {[1, 2, 3, 4, 5].map((star) => (
                              <Box
                                key={star}
                                sx={{
                                  fontSize: '1rem',
                                  color: star <= (review.rating || 5) ? '#FFD700' : '#ddd',
                                }}
                              >
                                ★
                              </Box>
                            ))}
                          </Box>

                                                 {/* Reviewer Info */}
                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                             <Avatar
                               src={review.user?.displayPicSrc || 'https://via.placeholder.com/40'}
                               alt={review.user?.firstName || 'Anonymous'}
                               sx={{ width: 32, height: 32 }}
                             />
                             <Box>
                               <Typography
                                 sx={{
                                   fontWeight: 600,
                                   fontSize: '0.8rem',
                                   color: '#333',
                                 }}
                               >
                                 {review.user?.firstName || 'Anonymous'}
                               </Typography>
                               <Typography
                                 sx={{
                                   fontSize: '0.7rem',
                                   color: '#666',
                                 }}
                               >
                                 {review.user?.lastName ? `${review.user.firstName} ${review.user.lastName}` : 'University of Greenwich, UK'}
                               </Typography>
                             </Box>
                           </Box>
                          
                                                     {/* LinkedIn Icon */}
                           <Box
                             sx={{
                               color: '#0077B5',
                               cursor: 'pointer',
                               '&:hover': { opacity: 0.8 },
                             }}
                           >
                             <Box
                               component="span"
                               sx={{
                                 fontSize: '1rem',
                                 fontWeight: 'bold',
                               }}
                             >
                               in
                             </Box>
                           </Box>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              {/* Navigation Arrow - Right */}
              {canShowNext && (
                <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <IconButton
                    onClick={handleNext}
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: '50%',
                      backgroundColor: '#F48438',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#E6732A',
                      },
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }}
                  >
                    <KeyboardArrowRightIcon />
                  </IconButton>
                </Grid>
              )}
            </>
          ) : (
            <Grid item xs={12} sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              mt: 4.5,
              pt: 0,
              ml:5
            }}>
                             <Box
                 sx={{
                   width: '100%',
                   maxWidth: 600,
                   background: '#fff',
                   borderRadius: '18px',
                   boxShadow: '0 4px 20px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)',
                   px: { xs: 4, md: 6 },
                   py: { xs: 2, md: 3 },
                   display: 'flex',
                   flexDirection: 'column',
                   alignItems: 'flex-start',
                   justifyContent: 'flex-start',
                   minHeight: 200,
                   position: 'relative',
                   mx: 'auto',
                 }}
               >
                                                   {/* Reviews Illustration peeking from top-right */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -80,
                      right: -8,
                      width: 100,
                      height: 100,
                      zIndex: 1,
                      overflow: 'hidden',
                    }}
                  >
                   <img 
                     src={Images.ReviewsIllustration} 
                     alt="Reviews Illustration"
                     style={{ 
                       width: '100%', 
                       height: '100%', 
                       objectFit: 'contain' 
                     }}
                   />
                 </Box>
                
                <Typography fontWeight={600} fontSize="1rem" sx={{ mb: 1, textAlign: 'left', color: '#495052' }}>
                  No reviews available for this yet.
                </Typography>
                                 <Typography color="#8E9091" fontSize="0.8rem" sx={{ mb: 0, fontWeight: 400, lineHeight: 1.5, textAlign: 'left' }}>
                   Be the first to tell others what to expect — your insights can make a difference!
                 </Typography>                
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    );
  };
  
  
  const CoursesOverview = ({ data }: any) => {
    const rating = [
      {
        name: "Academics",
        icon: Images.readingBook,
        grade: data?.rating?.Academics ? data?.rating?.Academics : "A+"
      },
      {
        name: "Value",
        icon: Images.value,
        grade: data?.rating?.Value ? data?.rating?.Value : "A+"
      },
      {
        name: "Athletics",
        icon: Images.athletics,
        grade: data?.rating?.Athletics ? data?.rating?.Athletics : "A+"
      },
      {
        name: "Diversity",
        icon: Images.diversity,
        grade: data?.rating?.Diversity ? data?.rating?.Diversity : "A+"
      },
      {
        name: "Party Scene",
        icon: Images.party,
        grade: data?.rating?.["Party Scene"] ? data?.rating?.["Party Scene"] : "A+"
      },
      {
        name: "Dorms",
        icon: Images.studentlife,
        grade: data?.rating?.Dorms ? data?.rating?.Dorms : "A+"
      },
      {
        name: "Campus Food",
        icon: Images.food,
        grade: data?.rating?.["Campus Food"] ? data?.rating?.["Campus Food"] : "A+"
      },
      {
        name: "Location",
        icon: Images.location,
        grade: data?.rating?.Location ? data?.rating?.Location : "A+"
      },
      {
        name: "Campus",
        icon: Images.campus,
        grade: data?.rating?.Campus ? data?.rating?.Campus : "A+"
      },
      {
        name: "Professors",
        icon: Images.professors,
        grade: data?.rating?.Professors ? data?.rating?.Professors : "A+"
      },
      {
        name: "Student Life",
        icon: Images.studentlife,
        grade: data?.rating?.["Student Life"] ? data?.rating?.["Student Life"] : "A+"
      },
      {
        name: "Safety",
        icon: Images.safety,
        grade: data?.rating?.Safety ? data?.rating?.Safety : "A+"
      },
    ];

    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        py: 2,
        px: 1,
        maxHeight: '350px',
        overflowY: 'auto'
      }}>
        <Grid container spacing={0} sx={{ maxWidth: 800 }}>
          {rating.map((item, index) => (
                         <Grid item xs={12} sm={6} md={4} key={index}>
               <Box sx={{
                 backgroundColor: '#fff',
                 borderRadius: '8px',
                 p: 1,
                 height: '45px',
                 display: 'flex',
                 flexDirection: 'row',
                 alignItems: 'center',
                 justifyContent: 'space-between',
                 boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                 border: '1px solid #f0f0f0',
                 position: 'relative',
                 mr: 3,
                 mb: 3,
                 '&:hover': {
                   boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                   transform: 'translateY(-1px)',
                   transition: 'all 0.2s ease'
                 }
               }}>
                 {/* Icon */}
                 <Box sx={{
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   width: '20px',
                   flexShrink: 0
                 }}>
                   <img 
                     src={item.icon} 
                     alt={item.name}
                     style={{ 
                       width: '16px', 
                       height: '16px',
                       filter: 'brightness(0.4)'
                     }} 
                   />
                 </Box>
                 
                 {/* Category Name */}
                 <Typography 
                   sx={{ 
                     fontSize: '0.85rem',
                     fontWeight: 500,
                     color: '#495052',
                    //  textAlign: 'center',
                     flexGrow: 1,
                     px: 0.5
                   }}
                 >
                   {item.name}
                 </Typography>
                 
                 {/* Grade Badge */}
                 <Box sx={{
                   backgroundColor: '#EAEAFF',
                   borderRadius: '6px',
                   px: 0.5,
                   py: 0.25,
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   minWidth: '20px',
                   flexShrink: 0
                 }}>
                   <Typography 
                     sx={{ 
                       fontSize: '0.75rem',
                       fontWeight: 600,
                       color: '#495052'
                     }}
                   >
                     {item.grade}
                   </Typography>
                 </Box>
               </Box>
             </Grid>
          ))}
        </Grid>
      </Box>
    );
  };
  const tabs = [
    {
      label: "About ",
      Component: (
        <div>
          <Information data={singleUniversityData} />
        </div>
      ),
    },
    // {
    //   label: "Information ",
    //   Component: (
    //     <div>
    //       <UniverInformation data={singleUniversityData} />
    //     </div>
    //   ),
    // },
    {
      label: "Courses Offered",
      Component: (
        <div style={{height:"100%",overflowY:"scroll",}}>
          <CoursesOffered data={totalCourses} />
          {/* Add pagination controls if needed */}
          {currentPage < totalPages && !coursesLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setCurrentPage(prev => prev + 1)}
                sx={{
                  borderRadius: '20px',
                  px: 3,
                  py: 1,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Load More Courses
              </Button>
            </Box>
          )}
        </div>
      ),
    },
    {
      label: "Campus Overview",
      Component: (
        <div >
          <CoursesOverview data={singleUniversityData} />
        </div>
      ),
    },
    {
      label: "Ranking",
      Component: (
       <div style={{height:"90%",overflowY:"scroll"}}>
        <Ranking data={singleUniversityData} />
        </div> 

      ),
    },

    {
      label: "Reviews",
      Component: (
       <div>
        <ReviewsData/>
       </div>
      ),
    },
    {
      label: "FAQs",
      Component: (
        <div>
          <FAQs data={singleUniversityData?.faqs} />
        </div>
      ),
    },
  ];

  const data = [
    {
      key: "Courses Offered",
      value: `${singleUniversityData?.courses}`,
      color: "#E1F4FF",
      label: `Courses Offered`,
      bgColor: "#E1F4FF"
    },
    {
      key: "Graduation Rate",
      value: `${singleUniversityData?.graduationRate ? singleUniversityData?.graduationRate : "N/A"}`,
      color: "#EAEAFF",
      label: "Graduation Rate",
      bgColor: "#EAEAFF"
    },
    {
      key: "Acceptance Rate",
      value: `${singleUniversityData?.acceptanceRate ? singleUniversityData?.acceptanceRate : "N/A"}`,
      label: "Acceptance Rate",
      color: "#FFF1DD",
      bgColor: "#FFF1DD"
    },
    {
      key: "Code",
      value: `${singleUniversityData?.code}`,
      color: "#FFEACB",
      label: "Code",
      bgColor: "#FFDFB0"
    },
    {
      key: "Living cost",
      value:  <Typography
      sx={{ fontSize: "14px", fontWeight: "500", margin: "5px 0px 0px -8px",display:"flex" }}
    >
      <Typography
  sx={{
    fontSize: "14px",
    // margin: "2px 2px 0 0",
    position: "relative",
    cursor:"pointer",
    "&:hover .cancel-icon": {
      display: "block !important",
    },
  }}
>
  {" "}
  {/* {singleUniversityData?.cost?.[0] ? singleUniversityData.currency.symbol : ""} */}
  <span
    className="cancel-icon"
    style={{
      display: "none",
      color: "#000",
    fontSize: "12px",
      position: "absolute",
      border: "1px solid #7d7d7d",
      width: "100px",
      zIndex: 1,
      background: "#fff",
      textAlign: "center",
     
    }}
  >
    Currency :{singleUniversityData?.currency?.code}
  </span>
</Typography>&nbsp;{" "}
      {formatCurrencyAmount(singleUniversityData?.cost?.[0]?.lowerLimit || 0, singleUniversityData?.currency?.code || 'INR')} -{" "}
      {formatCurrencyAmount(singleUniversityData?.cost?.[0]?.upperLimit || 0, singleUniversityData?.currency?.code || 'INR')}
    </Typography>,
      color: "#EAEAFF",
      label: "Living cost",
      bgColor: "#EAEAFF"
    },
    {
      key: "Median Earning",
      value: singleUniversityData?.medianEarning? "$ " +`${singleUniversityData?.medianEarning?.year}`:"N/A",
      color: "#FFEACB",
      label: "Median Earning",
      bgColor: "#FFDFB0"
    },
  ];

  const path = `/singleuniversity/${singleUniversityData?._id}`;
  return (
    <div className="universitydetails-popup" style={{ 
      height: "550px", 
      width: "100%",
      maxWidth: "1300px",
      overflowX: "hidden",
      overflowY: "hidden",
      position: "relative"
    }}>
      {loading ? (
        <Typography textAlign="center" sx={{ height: "200px" }}>Loading...</Typography>
      ) : (
        <Grid container spacing={2} sx={{ height: { xs: "70vh", lg: "550px" }}}>
          <Grid item xs={12} md={5} sx={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: '#F5EEE4',
            height: { xs: 'auto', md: '350px',lg:"450px" },
            borderRadius: { xs: 2, md: 3 },
            p: { xs: 2, md: 3 },
            mb: { xs: 2, md: 0 },
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08)',
          }}>
            <Box sx={{ 
              position: "relative", 
              zIndex: 1, 
              width: "100%",
              minHeight: "100%",
              display: "flex",
              flexDirection: "column"
            }}>
              <Typography color="#7d7d7d" sx={{ fontSize: { xs: "14px", md: "16px" }, mb: { xs: 1.5, md: 2 }, mt: { xs: 1.5, md: 3 }, textAlign: "center" }}>
                {singleUniversityData?.location?.city} {" > "}&nbsp;
                {singleUniversityData?.location?.state} {" > "}&nbsp;
                {singleUniversityData?.location?.country}
              </Typography>
              <Box sx={{ 
                borderRadius: "10px", 
                p: 1, 
                marginTop: "5%", 
                marginBottom: '20px',
                flex: 1
              }}>
                <Stack direction="column" sx={{ pl: { xs: 1, md: 3 }, pr: { xs: 1, md: 0 } }} spacing={2}>
                  <Box sx={{ marginTop: "1px !important", display: "flex", flexDirection: "column" }}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                    <img
                      src={singleUniversityData?.logoSrc}
                      alt="logo"
                      style={{ borderRadius: "50%", height: "1.5rem",marginTop:"8px" }}
                    />
                    <Button onClick={()=>{window.open("https://campusroot.com/singleuniversity/"+singleUniversityData?._id,"_blank")}} sx={{border:"none",backgroundColor:"transparent"}}>
                      <Typography
                        fontWeight="400"
                        sx={{
                          minWidth: "80%",
                          fontSize: { xs: "16px", lg: "20px" },
                          fontWeight: 500,
                          textTransform: "none",
                          maxWidth: { xs: "70vw", lg: "25vw" },
                          color: "#495052",
                        
                        
                        }}
                      >
                        {singleUniversityData?.name}
                      </Typography>
                    </Button>
                    </div>
                  </Box>
                  <Box sx={{ flexGrow: 1, width: "95%" }}>
                    <Grid container spacing={1}
                      sx={{
                        minWidth: { xs: '0', md: 'auto' },
                        border: '1.5px solid',
                        borderColor: 'grey.300',
                      borderRadius: { xs: '2.5%', md: '30px' },
                        backgroundColor: 'white',
                        paddingLeft: '14px',
                        paddingTop: '11px',
                        boxShadow: { xs: '0 2px 4px 0 rgba(109, 108, 108, 0.08)', md: '0px 2px 4px rgba(82, 81, 81, 0.08)' },
                        mt: { xs: 2, md: 8 },
                        ml:0.5
                      }}
                    >
                      {data.map((item, index) => (
                        <Grid item xs={6} md={6} lg={4} key={index} sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          py: 2,
                          px: 2,
                        }}>
                          <Box
                            sx={{
                              background: item.color || item.bgColor,
                              borderRadius: '20px',
                              position: 'relative',
                              px: { xs: 1, md: 2 },
                              py: { xs: 1, md: 2.5 },
                              height: { xs: '4rem', md: '4rem' },
                              width: { xs: '6.5rem', sm: '7rem', md: '4.5rem', lg: '6rem' },
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography
                              fontWeight="500"
                              color="#1C1F40CC"
                              sx={{ 
                                display: 'flex', 
                                gap: '5px', 
                                fontSize: { xs: '0.75rem', md: '0.85rem', lg: '0.75rem' },
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center'
                              }}
                            >
                              {item.label}
                            </Typography>
                            <Typography
                              color="#1C1F40"
                              fontWeight="600"
                              sx={{ 
                                fontSize: { xs: '1rem', md: '0.85rem', lg: '14px' },
                                textAlign: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                              }}
                            >
                              {item.value}
                            </Typography>
                            <p style={{
                              position: 'absolute',
                              right: '15px',
                              top: '60%', background: item.bgColor, width: "1rem", height: "1rem", margin: 0, borderBottomLeftRadius: "20px", transform: "rotate(65deg)"
                            }}></p>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={7} sx={{ 
            height: { xs: 'auto', md: '350px', lg: "450px" },
            display: "flex",
            flexDirection: "column"
          }}>
            {tabComponent === "tabs" ? (
              <Box sx={{ height: "100%", display: "flex", flexDirection: "column", marginTop: "20px" }}>
                <CustomTabs tabs={tabs} />
              </Box>
            ) : (
              <ArrowBack
                onClick={() => setTabComponent("tabs")}
                sx={{ cursor: "pointer" }}
              />
            )}
            {tabComponent === "tabs" ? (
              null
            ) :<Share link={path} />}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default UniversityDetailed;
